import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DealsRoutingModule } from './deals-routing.module';
import { DealsComponent } from './deals.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatDialogModule } from '@angular/material/dialog';
import { MatStepperModule } from '@angular/material/stepper';
import { FileUploadModule } from 'ng2-file-upload';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { DynamicFormModule } from 'src/app/shared/dynamic-form/dynamic-form.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { DirectiveModule } from 'src/app/shared/directive/directive.module';
import { SafepipeModule } from 'src/app/shared/safepipe/safepipe.module';
import { RestrictionPopUpModule } from 'src/app/shared/restriction-pop-up/restriction-pop-up.module';
import { TransferLeadModule } from 'src/app/shared/transfer-lead/transfer-lead.module';
import { AddEditdealsComponent } from './add-editdeals/add-editdeals.component';
import { DealsImportComponent } from './deals-import/deals-import.component';
import { CrmdealskanbanModule } from '../crmdealskanban/crmdealskanban.module';
import { DealskanbanModule } from '../dealskanban/dealskanban.module';
import { AddDealsPaymentComponent } from './add-deals-payment/add-deals-payment.component';
import { XlMapperModule } from '../../xl-mapper/xl-mapper.module';
import { DealsAdvanceXlComponent } from './deals-advance-xl/deals-advance-xl.component';
import { ViewDealsPaymentComponent } from './view-deals-payment/view-deals-payment.component';
import { ModuleNameModule } from 'src/app/shared/module-name-pipe/modulename.module';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { TrialExipedMessageModule } from 'src/app/shared/trial-exiped-message/trial-exiped-message.module';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { ColumnVisibilityModule } from 'src/app/shared/column-visibility/column-visibility.module';
import { ListModule } from 'src/app/shared/list/list.module';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DealEditPageComponent } from './deal-edit-page/deal-edit-page.component';
import { ActivityNewModule } from '../lead-detail/activity-new/activity-new.module';
import { ActivityModule } from '../activity/activity.module';
import { MatIconModule } from '@angular/material/icon';
import { IconModule } from '@visurel/iconify-angular';
import { AfterSalesPipelineTrackerModule } from 'src/app/shared/after-sales-pipeline-tracker/after-sales-pipeline-tracker.module';

@NgModule({
  declarations: [
    DealsComponent,
    AddEditdealsComponent,
    DealsImportComponent,
    AddDealsPaymentComponent,
    DealsAdvanceXlComponent,
    ViewDealsPaymentComponent,
    DealEditPageComponent
  ],
  imports: [
    CommonModule,
    DealsRoutingModule,
    DynamicFormModule,
    MatCheckboxModule,
    SharedModule,
    DirectiveModule,
    MatTableModule,
    MatSortModule,
    MatDialogModule,
    FileUploadModule,
    MatStepperModule,
    NgxMatSelectSearchModule,
    MatChipsModule,
    SafepipeModule,
    RestrictionPopUpModule,
    TransferLeadModule,
    DealskanbanModule,
    XlMapperModule,
    ModuleNameModule,
    CrmdealskanbanModule,
    ColumnVisibilityModule,
    TrialExipedMessageModule,
    MatAutocompleteModule,
    MatTooltipModule,
    ListModule,
    ActivityNewModule,
    ActivityModule,
    MatIconModule,
    IconModule,
    AfterSalesPipelineTrackerModule
  ], exports: [
    DealsComponent
  ],
})
export class DealsModule { }
